module.exports = __webpack_public_path__ + "img/stacketDashboard.35aca672.png";